import React, { useState, useEffect } from 'react';

/* Typed.js-style loop: types each string, pauses, deletes, moves to the next. */
function TypedHeading({ strings, className }) {
  const [text, setText] = useState('');
  const [stringIndex, setStringIndex] = useState(0);
  const [deleting, setDeleting] = useState(false);

  useEffect(() => {
    const current = strings[stringIndex];
    let timeout;

    if (!deleting && text === current) {
      timeout = setTimeout(() => setDeleting(true), 2000);
    } else if (deleting && text === '') {
      setDeleting(false);
      setStringIndex((stringIndex + 1) % strings.length);
    } else {
      timeout = setTimeout(() => {
        setText(current.slice(0, deleting ? text.length - 1 : text.length + 1));
      }, deleting ? 40 : 70);
    }

    return () => clearTimeout(timeout);
  }, [text, deleting, stringIndex, strings]);

  return <span className={className}>{text}</span>;
}

export default TypedHeading;
